'use client'

/**
 * Global presence heartbeat — POSTs the current user's online status every ~45s while signed
 * in and the tab is visible. This is what makes the online-users list work IN PRODUCTION, where
 * the browser socket is a no-op (so the socket-server's in-memory presence map is empty).
 */

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'

export default function PresenceHeartbeat() {
  const { status } = useSession()
  useEffect(() => {
    if (status !== 'authenticated') return
    const beat = () => {
      if (document.visibilityState !== 'visible') return
      fetch('/api/users/online-status', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status: 'online' }),
      }).catch(() => {})
    }
    beat()
    const iv = setInterval(beat, 45_000)
    const onVis = () => { if (document.visibilityState === 'visible') beat() }
    document.addEventListener('visibilitychange', onVis)
    return () => { clearInterval(iv); document.removeEventListener('visibilitychange', onVis) }
  }, [status])
  return null
}
